import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6f1fc8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav-header" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Fold = _resolveComponent("Fold")!
  const _component_Expand = _resolveComponent("Expand")!
  const _component_ZpBreadcrumb = _resolveComponent("ZpBreadcrumb")!
  const _component_NavUserInfo = _resolveComponent("NavUserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "head-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iconClick && _ctx.iconClick(...args)))
    }, [
      (_ctx.isIcon)
        ? (_openBlock(), _createBlock(_component_Fold, { key: 0 }))
        : (_openBlock(), _createBlock(_component_Expand, { key: 1 }))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ZpBreadcrumb, { breadcrumb: _ctx.breadcrumb }, null, 8, ["breadcrumb"]),
      _createVNode(_component_NavUserInfo)
    ])
  ]))
}